import { render, staticRenderFns } from "./staffSalary.vue?vue&type=template&id=debf9fb8&scoped=true&"
import script from "./staffSalary.vue?vue&type=script&lang=js&"
export * from "./staffSalary.vue?vue&type=script&lang=js&"
import style0 from "./staffSalary.vue?vue&type=style&index=0&id=debf9fb8&lang=scss&scoped=true&"
import style1 from "./staffSalary.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./staffSalary.vue?vue&type=style&index=2&id=debf9fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debf9fb8",
  null
  
)

export default component.exports